<template>
  <div class="container-page">
    <div>
      <p class="title-inner">Операции</p>
      <div class="mb-16">
        <ButtonComponent mod="gradient-bg" class="mr-2" @click="editCard(0)">Создать</ButtonComponent>
        <ButtonComponent mod="gradient-bg" :disabled="isExport" @click="exportExcel()">Экспорт</ButtonComponent>
      </div>
      <div class="mb-4">
        <DefaultFilter :filterValue="filter" @loadFilter="onLoadFilter" />
      </div>
      <div>
        <div class="table-container mb-16 js-table-arrow">
          <table class="stockTable">
            <thead>
              <tr>
                <th></th>
                <th>Название</th>
                <th>Статус</th>
                <th>Дата создания</th>
                <th>Дата изменения</th>
              </tr>
              <tr>
                <th class="filter"></th>
                <th class="filter">
                  <FilterInput v-model="filter.name" placeholder="Найти..." v-on:valueChangedDebounced="changeFilter" />
                </th>
                <th class="filter">
                  <FilterActiveInput
                    v-model="filter.isActive"
                    placeholder="(Все)"
                    v-on:valueChangedDebounced="changeFilter"
                  />
                </th>
                <th class="filter date-w-135">
                  <FilterInput
                    type="date"
                    modClass="filter-small"
                    v-model="filter.createdStart"
                    v-on:valueChangedDebounced="changeFilter"
                    :upperLimit="upperLimitCreationStart"
                    dateIcon
                  />
                  <FilterInput
                    type="date"
                    modClass="filter-small"
                    v-model="filter.createdEnd"
                    v-on:valueChangedDebounced="changeFilter"
                    :upperLimit="upperLimitEnd"
                    :lowerLimit="lowerLimitCreationEnd"
                    dateIcon
                  />
                </th>
                <th class="filter date-w-135">
                  <FilterInput
                    type="date"
                    modClass="filter-small"
                    v-model="filter.modifiedStart"
                    v-on:valueChangedDebounced="changeFilter"
                    :upperLimit="upperLimitModifiedStart"
                    dateIcon
                  />
                  <FilterInput
                    type="date"
                    modClass="filter-small"
                    v-model="filter.modifiedEnd"
                    v-on:valueChangedDebounced="changeFilter"
                    :upperLimit="upperLimitEnd"
                    :lowerLimit="lowerLimitModifiedEnd"
                    dateIcon
                  />
                </th>
              </tr>
            </thead>
            <tbody v-if="page.items?.length && !isLoading">
              <tr v-for="item in page.items" :key="item.id" @dblclick="editCard(item.id)">
                <td>
                  <div class="table__icons">
                    <IconComponent @click="openCloneCardModal(item)" name="copy3" />
                    <IconComponent @click="editCard(item.id)" name="edit" />
                    <IconComponent @click="deleteCard(item.id)" name="delete-not-fill" />
                  </div>
                </td>
                <td>{{ item.name }}</td>
                <td>{{ item.isActive ? 'действ.' : 'не действ.' }}</td>
                <td class="table-sort__td column-date-creation">
                  <p>
                    {{ $momentFormat(item?.created, DATE_FORMATS['DD.MM.YYYY']) }}
                    <br />
                    {{ $momentFormat(item?.created, DATE_FORMATS['HH:mm']) }}
                  </p>
                </td>
                <td class="table-sort__td column-date-change">
                  <p>
                    {{ $momentFormat(item?.modified, DATE_FORMATS['DD.MM.YYYY']) }}
                    <br />
                    {{ $momentFormat(item?.modified, DATE_FORMATS['HH:mm']) }}
                  </p>
                </td>
              </tr>
            </tbody>
            <tbody v-else-if="isLoading">
              <tr>
                <td class="text-center" colspan="6">Загрузка...</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td class="text-center" colspan="6">Нет данных.</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="page.pagesTotal > 1">
          <Pagination
            :pageCount="page.pagesTotal"
            :currentPage="page.pageNumber"
            @change="onPageChange($event, false)"
            @more="onPageChange($event, true)"
          />
        </div>
      </div>
    </div>
  </div>

  <!-- Окно копирования операции -->
  <ModalComponent title="Копирование операции" @close="closeCloneCardModal" v-model="cloneModal">
    <div class="custom-form">
      <div class="custom-form__block">
        <div class="custom-form__inputBlock">
          <p class="custom-form__label required">Название операции</p>
          <ComponentInput
            mod="redesigned"
            placeholder="Укажите название для новой операции"
            v-model="cloneCard.newName"
            :error="v$.cloneCard.$error"
            required
          />
        </div>

        <div class="custom-form__button-container">
          <ButtonComponent @click="cloneStep" mod="gradient-bg" :disabled="getDisabledButtonClone"
            >Копировать</ButtonComponent
          >
          <ButtonComponent @click="closeCloneCardModal">Отменить</ButtonComponent>
        </div>
      </div>
    </div>
  </ModalComponent>

  <!-- Окно оповещения -->
  <ModalInfo
    v-model="isOpenModalInfo"
    :titleModal="titleModal"
    :textModal="textModal"
    :modalIconName="modalIconName"
    @closeModal="closeModalInfo"
  />
</template>

<script>
  import { useVuelidate } from '@vuelidate/core';
  import { required } from '@vuelidate/validators';

  import ComponentInput from '@/common/components/ComponentInput.vue';
  import DefaultFilter from '@/common/components/DefaultFilter.vue';
  import FilterActiveInput from '@/common/components/FilterActiveInput.vue';
  import FilterInput from '@/common/components/FilterInput.vue';
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import ModalInfo from '@/common/components/redesigned/ModalInfo.vue';
  import Constants from '@/common/constants';
  import modalInfo from '@/common/mixins/modalInfo';
  import { loadFilter, saveFilter } from '@/common/utils/filterManager';

  import ModalComponent from '@/components/modals/ModalComponent.vue';

  import IconComponent from '../../../common/ui/IconComponent.vue';
  import API from '../api/step';
  import dateFormat from '../mixin/dateFormat.js';
  import { MODAL_INFO_MESSAGES } from '../utils/constants';

  export default {
    name: 'Steps',
    components: {
      IconComponent,
      ButtonComponent,
      FilterInput,
      FilterActiveInput,
      DefaultFilter,
      ModalComponent,
      ComponentInput,
      ModalInfo,
    },
    mixins: [dateFormat, modalInfo],
    data() {
      return {
        page: {},
        request: {
          pageNumber: 1,
          pageSize: Constants.pageSize,
          isTemplate: true,
        },
        isLoading: false,
        filter: {
          name: null,
          isActive: null,
          createdStart: '',
          createdEnd: '',
          modifiedStart: '',
          modifiedEnd: '',
        },
        isExport: false,
        DATE_FORMATS: Constants.DATE_FORMATS,
        cloneModal: false,
        cloneInProgress: false,
        cloneCard: {
          sourceId: null,
          newName: '',
        },
      };
    },
    setup: () => ({ v$: useVuelidate() }),
    validations() {
      return {
        cloneCard: {
          newName: { required },
        },
      };
    },

    created() {
      loadFilter(this.$options.name).then((response) => {
        let filter = response;
        if (filter) {
          this.filter = filter;
        }
        this.loadPage();
      });
    },
    computed: {
      getDisabledButtonClone() {
        return !this.cloneCard.newName || this.cloneInProgress;
      },
    },
    methods: {
      loadPage(append) {
        this.isLoading = true;
        const request = Object.assign(this.filter, this.request);
        API.search(request)
          .then((response) => {
            if (!append) {
              this.page = {};
              this.$nextTick(() => {
                this.page = response.data;
              });
            } else if (response.data) {
              this.page.pageNumber = response.data.pageNumber;
              this.page.items = this.page.items.concat(response.data.items);
            }
            this.isLoading = false;
          })
          .catch((error) => {
            this.isLoading = false;
            console.error(error?.response?.data);
          });
      },
      editCard(id) {
        this.$router.push({ name: 'StepCard', params: { id: id, action: 'edit' } });
      },
      deleteCard(id) {
        Constants.alert.fire(Constants.confirmOptions.delete).then((res) => {
          if (res.isConfirmed) {
            API.delete(id)
              .then((response) => {
                console.log(response);
                Constants.alert.fire('Удаление', 'Запись удалена', 'success');
                this.loadPage();
              })
              .catch((error) => {
                Constants.alert.fire(
                  'Удаление',
                  error.response && error.response.data ? error.response.data : 'Запись не удалена',
                  'error',
                );
              });
          }
        });
      },
      onPageChange(pageNumber, addToExist) {
        this.request.pageNumber = pageNumber;
        this.loadPage(addToExist);
      },
      changeFilter() {
        this.request.pageNumber = 1;
        saveFilter(this.$options.name, this.filter);
        this.loadPage(false);
      },
      onLoadFilter(item) {
        this.filter = item;
        this.changeFilter();
      },
      exportExcel() {
        this.isExport = true;
        const request = Object.assign(this.filter, this.request);
        API.exportExcel(request)
          .then(() => {
            this.isExport = false;
          })
          .catch(() => {
            this.isExport = false;
          });
      },
      openCloneCardModal(item) {
        this.v$.$reset();
        this.cloneCard.sourceId = item.id;

        this.cloneModal = true;
      },
      closeCloneCardModal() {
        this.cloneCard.sourceId = null;
        this.cloneCard.newName = '';

        this.cloneInProgress = false;
        this.cloneModal = false;
      },
      cloneStep() {
        this.v$.$touch();
        if (this.v$.cloneCard.$invalid) return;

        this.cloneInProgress = true;
        API.clone(this.cloneCard)
          .then(() => {
            this.titleModal = 'Сохранено';
            this.textModal = MODAL_INFO_MESSAGES.COPY_STEP_SUCCESS;
            this.modalIconName = Constants.MODAL_INFO_ICON.ACCEPT;
            this.loadPage();
          })
          .catch(() => {
            this.titleModal = 'Ошибка';
            this.textModal = MODAL_INFO_MESSAGES.COPY_STEP_ERROR;
            this.modalIconName = Constants.MODAL_INFO_ICON.ERROR;
          })
          .finally(() => {
            this.isOpenModalInfo = true;
            this.cloneInProgress = false;
            this.closeCloneCardModal();
          });
      },
    },
  };
</script>

<style scoped lang="scss">
  @import '@/assets/theme/default/custom-form.scss';

  .table__icons {
    display: flex;
    gap: 8px;
  }

  .stockTable {
    min-height: 65vh;

    tr {
      vertical-align: top;
    }
  }
</style>
